/**
 * Environment access.
 *
 * The project rule, on the client: never `import.meta.env.X || "default"`. A
 * fallback hides a misconfiguration, and the specific misconfiguration this
 * prevents is a development build silently pointing at production data because
 * `VITE_USE_EMULATOR` was spelled wrong.
 *
 * An ESLint rule forbids the `||` and `??` forms, so this is the only way in.
 */
export function requireEnv(key: string): string {
  const value = (import.meta.env as Record<string, string | undefined>)[key];
  if (value === undefined || value === "") {
    throw new Error(`[config] Missing required environment variable: ${key}`);
  }
  return value;
}

/**
 * Accepts only "true" or "false".
 *
 * Not truthiness. `VITE_USE_EMULATOR="flase"` is falsy under a loose check and
 * would connect a developer to the real project without a word.
 */
export function requireEnvBoolean(key: string): boolean {
  const value = requireEnv(key);
  if (value === "true") return true;
  if (value === "false") return false;
  throw new Error(
    `[config] ${key} must be "true" or "false", not "${value}". ` +
      `A typo here points a development build at production data.`
  );
}
